import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { DolEditor } from '@doltech/ui/lib/figma/DolEditor/DolEditor';
import { COUNT_ITEM } from '@doltech/ui/lib/figma/DolEditor/elements/sentences-count/renderElement';
import { useSideToolbarPlugins } from '@doltech/ui/lib/figma/DolEditor/toolbars/sidebar/defaults';
import dynamic from 'next/dynamic';
import * as React from 'react';
import { Element } from 'slate';
import styled from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

const ExplanationCard = dynamic(import('./ExplanationCard'));

const EditorWrapper = styled.div`
  width: 100%;
  > .dol-editor {
    > .editor-content-wrapper {
      line-height: 28px;
      ${fromScreen(768)} {
        max-width: 91vw;
      }
    }
  }
  strong {
    span {
      color: ${colorsV2.black100};
    }
  }
`;

interface ParaphrasingComponentProp extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  initValue?: any;
  showTitle?: boolean;
  limit?: number | boolean;
  withCardLayout?: boolean;
}

export const ParaphrasingViewOnlyComponent = (props: ParaphrasingComponentProp) => {
  const { title, initValue, showTitle, limit = false, withCardLayout = true } = props;
  const { editorChains, plugins } = useSideToolbarPlugins({});
  const getData = (data: any) => {
    if (!data) {
      return undefined;
    }
    if (Array.isArray(data)) {
      return data;
    }

    const result = Array.from(JSON.parse(data)).filter((n) => Element.isElement(n)) as any;
    ((result[0] as any)?.children || []).forEach((item, index) => {
      if (item.type === COUNT_ITEM) {
        result[0].children.splice(index, 1);
      }
    });

    if (limit) {
      result.splice(limit);
    }
    return result;
  };

  if (withCardLayout) {
    return (
      <ExplanationCard title={title} showTitle={showTitle}>
        <EditorWrapper>
          <DolEditor
            readOnly
            placeholder={initValue}
            initialValue={getData(initValue) as any}
            plugins={plugins}
            editorChains={editorChains}
          />
        </EditorWrapper>
      </ExplanationCard>
    );
  }

  return (
    <DolEditor
      readOnly
      placeholder={initValue}
      initialValue={getData(initValue) as any}
      plugins={plugins}
      editorChains={editorChains}
    />
  );
};
